<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="filtertool">
    <div class="head">
        <h1><i class="{{icon}}" aria-hidden="true"></i> {{ title }}</h1>
    </div>

    <div class="content">
        <div class="toolbar mt-2">
            <label class="mr-2" for="select-opgeslagen-filter">Opgeslagen filters:</label>
            <ng-select id="select-opgeslagen-filter"
                       [appendTo]="dropdownContainer"
                       [items]="opgeslagenFilters"
                       bindLabel="naam"
                       [clearable]="false"
                       placeholder="Kies een opgeslagen filter..."
                       [(ngModel)]="geselecteerdFilter"
                       (change)="opgeslagenFilterGeselecteerd($event)">
                <ng-template ng-option-tmp let-item="item">
                    {{ item.naam }}
                    @if(item.gebruiker_id === api.uid && item.publiek) {
                        <span class="fas fa-globe text-muted ml-1" title="Publiek" aria-label="Publiek"></span>
                    }
                    @if(item.gebruiker_id !== api.uid) {
                        ({{ gebruikersOpId[item.gebruiker_id]?.naam || 'onbekend' }})
                    }
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{ item.naam }}
                    @if(item.gebruiker_id === api.uid && item.publiek) {
                        <span class="fas fa-globe text-muted ml-1" title="Publiek" aria-label="Publiek"></span>
                    }
                    @if(item.gebruiker_id !== api.uid) {
                        ({{ gebruikersOpId[item.gebruiker_id]?.naam || 'onbekend' }})
                    }
                </ng-template>
            </ng-select>
            <div class="mt-2">
                @if (geselecteerdFilter) {
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               class="custom-control-input"
                               [id]="id('publiekbeschikbaar')"
                               [(ngModel)]="geselecteerdFilter.publiek"
                               [disabled]="!isEigenGeselecteerdFilter">
                        <label class="custom-control-label" [for]="id('publiekbeschikbaar')">
                            Publiek beschikbaar
                        </label>
                    </div>
                }
            </div>
            <div class="mt-2 linksrechts">
                <div links>
                    <button class="btn btn-sm btn-outline-primary mr-2"
                            (click)="slaHuidigFilterOp()"
                            [disabled]="!kanOpslaanFilter">
                        Huidige filter bewaren
                    </button>
                    <button class="btn btn-sm btn-outline-secondary mr-2"
                            (click)="slaHuidigFilterOpAls()">
                        Huidige filter bewaren als...
                    </button>
                    <button class="btn btn-sm btn-outline-secondary"
                            (click)="maakNieuwFilter()">
                        Huidige filter legen
                    </button>
                </div>
                <div rechts>
                    @if (geselecteerdFilter) {
                        <button class="btn btn-sm btn-outline-danger"
                                (click)="verwijderGeselecteerdFilter()"
                                [disabled]="!kanVerwijderenFilter">
                            Huidge filter verwijderen
                        </button>
                    }
                </div>
            </div>
        </div>
        <div class="regels-lijst mt-3">
            <filtergroep
                    [groep]="boom"
                    [dropdownContainer]="dropdownContainer"
                    (verwijderClausule)="onRegelVerwijder($event)"
                    (voegNieuweRegelToeInGroep)="voegNieuweRegelToeInGroep($event)"
                    (verplaatsRegelNaarParent)="onVerplaatsRegelNaarParent($event)"
                    (wikkelRegelInGroep)="onWikkelRegel($event)"></filtergroep>
        </div>
    </div>
    <div class="foot">
        <div class="buttons" links>
            <button class="btn btn-secondary" (click)="annuleer()">{{ isDirty ? 'Annuleren' : 'Sluiten' }}</button>
        </div>
        <div class="buttons" rechts>
            <button class="btn btn-info mr-2" (click)="pasToe()" [disabled]="!isDirty || !isValid">Toepassen</button>
            <button class="btn btn-primary" (click)="opslaan()" [disabled]="!isDirty || !isValid">Toepassen &amp; sluiten</button>
        </div>
    </div>
</div>
